module.exports = __webpack_public_path__ + "img/hr-sand-decal-30.416e7951.png";